/* eslint-disable */
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import ddpi from "../image/ddpi-banner3.svg";
import "../components/css/login.css";
import randomkey from "../config/randomfunc.mjs";
import clientapifunc from "../service/clientapi.mjs";
import Mobcarousel from "./Mobcarousel";
import { useEffect, useState } from "react";
import Modalfunc from "./modal";
import secureLocalStorage from "react-secure-storage";
import Faqfunc from "./faq";

function Login(props) {
  const Navigate = useNavigate();
  const [Loader, setLoader] = useState();

  var invalidChars = [
    "-",
    "+",
    ".",
    " ",
    "@",
    "#",
    "!",
    "$",
    "₹",
    "%",
    "^",
    "&",
    "*",
    "(",
    ")",
    "{",
    "}",
    "[",
    "]",
    "`",
    "~",
    "'",
    '"',
    "<",
    ">",
    "?",
    ",",
    ":",
    ";",
    "|",
    "=",
    "_",
    "/",
    "\\"

  ];
  let Randomkey = "";
  let UserCC = "";
  let msg = {};
  // FUNCTION:
  //====================

  function redirect() {
    document.querySelector(".Featurescomp").style.display = "none";
    document.querySelector(".footer-text").style.display = "none";
    document.querySelector(".login-container").style.display = "block";
  }

  function getccinput(e){
    UserCC=e.target.value;
  }

  async function warn() {
    invalidChars.forEach(item=>{
      if(UserCC.includes(item)){
        toast.warn("Special characters are not allowed", {
          style:{
            fontSize:"12px"
          },
          toastId: "success1",
        });
        return;
      }
    })
    if (UserCC.length == 0) {
      toast.warn("Please Enter Client Code", {
        style:{
          fontSize:"12px"
        },
        toastId: "success1",
      });
    }else{
      Randomkey = randomkey();
      msg = await clientapifunc(UserCC, Randomkey);
      // console.log(msg.message);
      if (msg.message === "Invalid CC") {
        toast.error("Invalid Client Code", {
          style:{
            fontSize:"12px"
          },
          toastId: "success1",
        });
      }
      if(msg.message==="Your demat account is not with AGSL"){
        toast.warn(msg.message, {
          style:{
            fontSize:"12px"
          },
          toastId: "success1",
        });
      }
      if(msg.message==="Something went wrong while Validating client"){
        toast.warn("Client not found, Please try again later!", {
          style:{
            fontSize:"12px"
          },
          toastId: "success1",
        });
      }
      if(msg.message==="Your demat account is not with AGSL"){
        toast.warn(msg.message, {
          style:{
            fontSize:"12px"
          },
          toastId: "success1",
        });
      }
      if (msg.message === "Already a POA active Client") {
        toast.warn("Already a POA active Client", {
          style:{
            fontSize:"12px"
          },
          toastId: "success1",
        });
      }
      if (msg.message === "Request successful") {
        setLoader(true);
        props.passclientcode(UserCC);
        props.passuniqueId(Randomkey);
        toast.success("OTP sent on Your Mobile/Email", {
          style:{
            fontSize:"12px"
          },
          toastId: "success1",
        });
        setTimeout(() => {
          Navigate("/otp");
        }, 2500);
      }
    }
  }

  useEffect(()=>{
    secureLocalStorage.clear();
  },[])

  return (
    <>
      <div className="container">
        <div className="Featurescomp w-full h-2/4 md:hidden">
          <div
            className="absolute border-0 bottom-[0] right-2  text-md font-medium "
            onClick={() => redirect()}
          >
            <p className="cursor-pointer text-blue-800 flex items-center justify-end mb-8">
              <u>Continue</u>
              <Icon icon="material-symbols:keyboard-arrow-right" />
            </p>
            <p className="footer-text footer w-[100%] text-[10px] m-auto text-center">
              Almondz Global Securities Limited <br/>CIN: L74899DL1994PLC059839
              | Tel. No.: 011-43500700 | Website: www.almondz.com |<br></br>
              Email: helpdesk@almondz.com | SEBI Reg. No. INZ000213936 | Member:
              NSE: 12252 | BSE: 3055 Copyright © 2023 Almondz Global Securities
              Limited. All rights reserved.
            </p>
          </div>
          <Mobcarousel />
        </div>
        <div className="login-container max-md:flex max-md:flex-col">
          <div className="upper-column">
            <h1 className="main-heading">Enable DDPI</h1>
            <div className="loginimg">
              <img src={ddpi} alt="ddpi"></img>
            </div>
            <p className="client-desc para mt-5 mb-10"></p>
            <input
              type="text"
              onChange={(e) => getccinput(e)}
              onKeyDown={(e) => {
                if (invalidChars.includes(e.key)) {
                  e.preventDefault();
                }
                if(e.key==="Enter"){
                  warn();
                }
              }}
              onInput={(e) => (e.target.value = e.target.value.slice(0, 12))}
              placeholder="Enter Your Client Code"
              className="mt-[12vh] sm:mt-8"
            />
            <ToastContainer
              position="top-right"
              autoClose={2500}
              transition={Slide}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </div>

          <div className="button-box text-center">
            {Loader === true ? (
              <svg
                class="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  class="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  class="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
            ) : (
              <button className="active-btn" onClick={() => warn()}>
                Send OTP
              </button>
            )}

            <p className="small-text mx-8 text-black">
              By clicking "Send OTP" I accept <Modalfunc />
              {/* <Link className="link-text"> Terms & Condition.</Link> */}
            </p>
          </div>
        </div>
      </div>
      <div className=""><Faqfunc /></div>
      <p className="absolute w-[100%] text-[10px] m-auto text-center bottom-1 hidden md:block">
        Almondz Global Securities Limited <br></br>CIN: L74899DL1994PLC059839 | Tel.
        No.: 011-43500700 | Website: www.almondz.com |<br></br>
        Email: helpdesk@almondz.com | SEBI Reg. No. INZ000213936 | Member: NSE:
        12252 | BSE: 3055 Copyright © 2023 Almondz Global Securities Limited.
        All rights reserved.
      </p>
    </>
  );
}
export default Login;
